import ProviderVariantEdit from "./edit";

export default ProviderVariantEdit;
